<div class="intl-phone-component" [class.disabled]="isCountryDisabled">
  <div class="display-selected" [class.open]="isOpen" (click)="onClosing()" [class.all-disabled]="disabled">
    <span [class]="'flag ' + selectedCountry.flagClass"></span>
    <span class="prefix">{{ selectedCountry.phonePrefix }}</span>
    <svg width="6" height="4" viewBox="0 0 6 4" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M1 1L3 3L5 1" stroke="#637EFF" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
    </svg>
  </div>
  <form [formGroup]="form" [class.open]="isOpen" [class.disabled]="disabled">
    <input
      matInput
      aria-label="Country"
      [class.open]="isOpen"
      placeholder="Search country name/code"
      [matAutocomplete]="auto"
      formControlName="country"
      (blur)="blurOutput(false)"
      [readonly]="isCountryDisabled"
      [matAutocompletePosition]="'below'"
      #trigger="matAutocompleteTrigger"
      id="countries-search" />
    <input
      id="phone"
      data-testid="intl-phone-number"
      matInput
      numbersPlusOnly
      [placeholder]="selectedCountry.placeHolder || ''"
      type="tel"
      (blur)="blurOutput()"
      aria-label="Phone"
      #phoneField
      formControlName="numberWithoutPrefixForDisplay" />
    <mat-autocomplete
      id="countries-dd"
      #auto="matAutocomplete"
      class="intl-phone-countries-dd"
      (opened)="onOpenDD()"
      (closed)="onCloseDD(phoneField)"
      (optionSelected)="onOptionSelected($event)">
      <mat-option
        *ngFor="let country of filteredCountries | async"
        [value]="country.phonePrefix"
        class="intl-phone-option"
        [disabled]="!country?.phonePrefix"
        [class.gb]="country.code === 'GB'"
        (click)="selectCountry(country)">
        <span [class]="'flag flag--option ' + country?.flagClass"></span>
        <span *ngIf="country.phonePrefix"
          ><span class="bold">{{ country?.name }}</span> ({{ country?.phonePrefix }})</span
        >
        <span class="no-results" *ngIf="!country.phonePrefix"
          >No results for "<span class="bold">{{ form.controls['country'].value }}"</span></span
        >
      </mat-option>
    </mat-autocomplete>

    <input type="hidden" formControlName="phone" />
  </form>
</div>
